import './index.scss';
import React, { useState, useCallback, useEffect } from 'react';
import { useDropzone } from "react-dropzone";
import axios from 'axios';
import Utils from '../../CourseApp/Helper/utils';
import imageCompression from 'browser-image-compression';

import {
    IconPlusSmallWhite
} from '../../icons/svgs';
import manager from '../../Manager';
// import ReactCrop from "react-image-crop";
// import "react-image-crop/dist/ReactCrop.css";

function ImageControl({ structure, saveValue, defaultValue, controlKey, runtimeValue, showModalCrop }) {

    const [controlValue, setControlValue] = useState(defaultValue ?? {});

    const controlRules = structure?.rules;
    const controlRulesAllowedFileType = controlRules.allowedFileType ? controlRules.allowedFileType : ['.jpg'];
    const controlRulesMaxFileSize = controlRules.maxFileSize;
    const fileManagerUrl = manager.settings.filemanagerUrl;
    const tempUploadUrl = fileManagerUrl + '/temp';

    const onDrop = useCallback(async (acceptedFiles) => {
        // setFiles(acceptedFiles.map(file => Object.assign(file, {
        //     preview: URL.createObjectURL(file)
        // })));
        // console.log(acceptedFiles);
        // console.log(files);

        const file = acceptedFiles[0];
        const validExtensions = controlRulesAllowedFileType;

        // // Validasi tipe file
        const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
        if (!validExtensions.includes(fileExtension)) {
            Utils.showError('allowed file type .' + validExtensions);
            return;
        }

        // // validate file size
        if (file.size > controlRulesMaxFileSize) {
            Utils.showError('Maximum file size: ' + Utils.convertBytes(controlRulesMaxFileSize));
            return;
        }
        let url = await showModalCrop(file, 3/2);
        // console.log(file);
        // console.log(url);
        uploadFile(Utils.base64ToImageFile(url, file.name));
        // openCropModal();
    }, []);

    const { getRootProps, getInputProps } = useDropzone({
        accept: {
            'image/*': []
        },
        multiple: false,
        maxFiles: 1,
        onDrop
    });

    const uploadFile = async (file) => {
        // do compress image if not gif
        if ( file.type !== "image/gif" ) {
            const compressOptions = {
                maxSizeMB: 2,
                useWebWorker: true,
                maxWidthOrHeight: 1024, // decrease file size
                initialQuality: 0.7,
            };
            const result = await imageCompression( file, compressOptions );
            if ( result ) {
                file = new File([result], file.name, {type:file.type});
            }
        }
        const formData = new FormData();
        formData.append('file', file);

        axios
            .post(tempUploadUrl, formData)
            .then((response) => {
                let responseData = response.data;
                let errCode = responseData.errCode;
                let errMessage = responseData.errMessage;
                let data = responseData.data;
                if (errCode > 0) {
                    Utils.showError(errMessage);
                }
                if (errCode === 0) {
                    // console.log(data);
                    let fileUploaded = data.file[0];
                    // let fileId = fileUploaded.fileId;
                    // let fileName = fileUploaded.filename;
                    // let fullUrl = fileUploaded.fullUrl;
                    // let size = fileUploaded.size;
                    // let type = fileUploaded.type;
                    setControlValue(fileUploaded);
                    saveValue(fileUploaded);
                }
            })
            .catch((error) => {
                Utils.showError('An error occurred while uploading the file:' + error);
            });
    };

    useEffect(() => {
        if (typeof defaultValue !== 'undefined') {
            setControlValue(defaultValue);
        } else {
            setControlValue('');
        }
    }, [defaultValue]);

    return (
        <>
            <div className="tbcourse-editor-control-item-label">
                {structure.labelOnChangeOption}
            </div>
            <div className="tbcourse-editor-control-image">
                {Object.keys(controlValue).length === 0 ? (
                    <div {...getRootProps({ className: 'dropzone-wrapper' })}>
                        <input {...getInputProps()} />
                        <div className='upload-area'>
                            <IconPlusSmallWhite />
                        </div>
                    </div>
                ) : (
                    <div className='upload-preview'>
                        <div className='image-thumbnail' key={runtimeValue?.fileId ?? controlValue?.fileId}>
                            <div className='image-thumbnail-wrapper' style={{ backgroundImage: 'url(' + runtimeValue?.fullUrl ?? controlValue?.fullUrl + ')' }}>
                                <img
                                    alt='preview'
                                    src={runtimeValue?.fullUrl ?? controlValue?.fullUrl}
                                // Revoke data uri after image is loaded
                                // onLoad={() => { URL.revokeObjectURL(file.preview) }}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}

export default ImageControl;
